import { Group } from "@mantine/core"
import type { ReactNode } from "react"

export type AppTopBarProps = {
  /** Left-aligned slot. Typical content: brand mark + app name, or page title. */
  readonly left?: ReactNode
  /** Center slot (rare). Typical content: breadcrumb or search. */
  readonly center?: ReactNode
  /** Right-aligned slot. Typical content: audience toggle, theme toggle, user avatar, sign-out. */
  readonly right?: ReactNode
}

/**
 * AppTopBar — slot-based header for Civala AppShell chrome.
 *
 * Renders inside a Mantine `AppShell.Header`. Styling comes from
 * `pitch-global.css` `.civala-chrome-pitch` rules — wrap `AppShell`
 * with that class for the scheme-aware light/dark treatment.
 *
 * The component itself is unopinionated about content. Each consumer
 * passes its own brand mark, page title, controls, etc.
 */
export function AppTopBar({ left, center, right }: AppTopBarProps) {
  return (
    <Group h="100%" px="md" justify="space-between" wrap="nowrap">
      <Group gap="sm" wrap="nowrap">
        {left}
      </Group>
      {center != null && (
        <Group gap="sm" wrap="nowrap">
          {center}
        </Group>
      )}
      <Group gap="sm" wrap="nowrap">
        {right}
      </Group>
    </Group>
  )
}
